import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./ShareNP.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import faceBookShareIcon from "./images/facebookShare.svg";
import XshareSVG from "./images/XshareSVG";
import WhatsAppSVG from "./images/WhatsAppSVG";
import ShareSvg from "@/pages/post/components/InspectionView/imagesSVG/ShareSvg";
import { trackEvents } from "@/common/events/events";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import AddToFavoriteButton from "@/common/HOCs/AddToFavorite/AddToFavoriteButton";
import useHelpers from "@hooks/useHelpers";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
import { twMerge } from "tailwind-merge";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
var CopyButton = function CopyButton(_ref) {
  var copyCodeRef = _ref.copyCodeRef,
    isReport = _ref.isReport;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    copyDone = _useState[0],
    setCopyDone = _useState[1];
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers;
  useEffect(function () {
    copyDone && setTimeout(function () {
      setCopyDone(false);
    }, 3000);
  }, [copyDone]);
  var copyTheCode = function copyTheCode() {
    copyCodeRef.current.select();
    document.execCommand("copy");
    setCopyDone(true);
    isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
      share_medium: "copy_link"
    })) : trackEvents("post_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
      share_medium: "copy_link"
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, copyDone ? /*#__PURE__*/React.createElement("span", {
    className: stl.doneCopyCont
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Check.svg",
    alt: "done"
  }), " ", t("link_copied", {
    ns: "web_post_view"
  })) : /*#__PURE__*/React.createElement("button", {
    onClick: copyTheCode,
    className: "blueBtn"
  }, t("copy_link", {
    ns: "web_post_view"
  })));
};
var ShareNP = function ShareNP(props) {
  var _useTranslation2 = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation2.t;
  var _usePostDetails2 = usePostDetails(),
    helpers = _usePostDetails2.helpers;
  var _useState2 = useState(false),
    showPopUp = _useState2[0],
    setShowPopUp = _useState2[1];
  var copyCodeRef = useRef();
  var _useState3 = useState(props.postDynamicLink ? props.postDynamicLink : ""),
    textToCopy = _useState3[0],
    setTextToCopy = _useState3[1];
  var _useHelpers = useHelpers(),
    createUrlAbsolute = _useHelpers.createUrlAbsolute;
  var isMobile = useIsMobile();
  useEffect(function () {
    setTextToCopy(props.postDynamicLink ? props.postDynamicLink : "");
  }, [props.postDynamicLink]);
  return isMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, props.renderTrigger ? props.renderTrigger(function () {
    return setShowPopUp(true);
  }) : /*#__PURE__*/React.createElement("div", {
    className: stl.mobileShare,
    onClick: function onClick() {
      return setShowPopUp(true);
    },
    id: "share-button-mobile"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    className: stl.androidSH,
    src: CDN_LINK + "/assets/images/android_share.svg",
    alt: "icon",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("img", {
    className: stl.iosSH,
    src: CDN_LINK + "/assets/images/ios_share.svg",
    alt: "icon",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showPopUp,
    onClose: function onClose() {
      return setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.sharePostContainerP
  }, /*#__PURE__*/React.createElement("h3", null, props.reportShare ? t("share_inspection_report", {
    ns: "web_post_view"
  }) : t("share_advertisement", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.socalBtns
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/sharer.php?u=".concat(textToCopy),
    "aria-label": t("facebook", {
      ns: "web_post_view"
    }),
    onClick: function onClick() {
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Facebook"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Facebook"
      }));
      textToCopy;
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    width: 48,
    height: 48,
    src: faceBookShareIcon,
    alt: "faceBbok share"
  }), /*#__PURE__*/React.createElement("span", null, t("facebook", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fsyarah.com&ref_src=twsrc%5Etfw&tw_p=tweetbutton&url=" + createUrlAbsolute("/cardetail/".concat(helpers.getPostId())),
    "aria-label": t("twitter", {
      ns: "web_post_view"
    }),
    onClick: function onClick() {
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Twitter"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Twitter"
      }));
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(XshareSVG, null), /*#__PURE__*/React.createElement("span", null, t("twitter", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "m-show",
    href: "whatsApp://send?text=%0A%0A ".concat(textToCopy),
    "aria-label": t("whatsapp", {
      ns: "web_post_view"
    }),
    onClick: function onClick() {
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Whatsapp"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Whatsapp"
      }));
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(WhatsAppSVG, null), /*#__PURE__*/React.createElement("span", null, t("whatsapp", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: [stl.copyDataContainer, stl.copyLink].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    ref: copyCodeRef,
    id: "linkCopy",
    type: "text",
    readOnly: true,
    value: decodeURI(textToCopy)
  }), /*#__PURE__*/React.createElement(CopyButton, {
    copyCodeRef: copyCodeRef,
    isReport: props.isReport
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.flex, props.btnClass ? props.btnClass : undefined].join(" "),
    id: "share-favorite-container"
  }, !props.hideFavaorite && /*#__PURE__*/React.createElement("div", {
    className: stl.conatiner
  }, /*#__PURE__*/React.createElement(AddToFavoriteButton, {
    postId: helpers.getPostId(),
    className: stl.FavoriteButton,
    g4_data: helpers.getG4_data(),
    renderFunction: function renderFunction(favClickHandler, isFavorite) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: twMerge("bg-white rounded-full shadow-md focus:outline-none transition-colors w-8 h-8 flex items-center justify-center flex-shrink-0", stl.FavoriteButton),
        onClick: favClickHandler,
        role: "button",
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.currentTarget.click();
          }
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: isFavorite ? "material-symbols--favorite-rounded" : "material-symbols--favorite-outline-rounded",
        width: 5,
        height: 5,
        className: "fill-current text-primary flex-shrink-0"
      })), /*#__PURE__*/React.createElement("span", {
        onClick: favClickHandler
      }, t("add_favorites", {
        ns: "web_post_view"
      })));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.conatiner,
    onClick: function onClick() {
      return setShowPopUp(true);
    },
    id: "share-button-desktop"
  }, /*#__PURE__*/React.createElement("img", {
    width: 15,
    height: 16,
    className: "m-hide",
    src: CDN_LINK + "/assets/bundles/share.svg",
    alt: "share"
  }), /*#__PURE__*/React.createElement(ShareSvg, {
    className: "m-show"
  }), /*#__PURE__*/React.createElement("span", {
    className: "m-hide"
  }, props.reportShare ? t("share_inspection_report_2", {
    ns: "web_post_view"
  }) : t("share_post", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showPopUp,
    onClose: function onClose() {
      return setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.sharePostContainerP
  }, /*#__PURE__*/React.createElement("h3", null, props.reportShare ? t("share_inspection_report", {
    ns: "web_post_view"
  }) : t("share_advertisement", {
    ns: "web_post_view"
  })), helpers.getMainImage() && helpers.getPostTitle() && /*#__PURE__*/React.createElement("div", {
    className: stl.carTitle_image
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: helpers.getMainImage(),
    alt: helpers.getPostTitle()
  })), /*#__PURE__*/React.createElement("strong", null, helpers.getPostTitle())), /*#__PURE__*/React.createElement("div", {
    className: stl.socalBtns
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/sharer.php?u=".concat(textToCopy),
    "aria-label": t("facebook", {
      ns: "web_post_view"
    }),
    onClick: function onClick() {
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Facebook"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Facebook"
      }));
      textToCopy;
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    width: 48,
    height: 48,
    src: faceBookShareIcon,
    alt: "facebbok"
  }), /*#__PURE__*/React.createElement("span", null, t("facebook", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fsyarah.com&ref_src=twsrc%5Etfw&tw_p=tweetbutton&url=" + createUrlAbsolute("/cardetail/".concat(helpers.getPostId())),
    "aria-label": t("twitter", {
      ns: "web_post_view"
    }),
    onClick: function onClick() {
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Twitter"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Twitter"
      }));
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(XshareSVG, null), /*#__PURE__*/React.createElement("span", null, t("twitter", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "m-show",
    href: "whatsApp://send?text=%0A%0A ".concat(textToCopy),
    "aria-label": t("whatsapp", {
      ns: "web_post_view"
    }),
    onClick: function onClick() {
      props.isReport ? trackEvents("inspection_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Whatsapp"
      })) : trackEvents("post_share", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        share_medium: "Whatsapp"
      }));
    },
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(WhatsAppSVG, null), /*#__PURE__*/React.createElement("span", null, t("whatsapp", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: [stl.copyDataContainer, stl.copyLink].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    ref: copyCodeRef,
    id: "linkCopy",
    type: "text",
    readOnly: true,
    value: decodeURI(textToCopy),
    className: stl.inputDir
  }), /*#__PURE__*/React.createElement(CopyButton, {
    copyCodeRef: copyCodeRef,
    isReport: props.isReport
  })))));
};
export default ShareNP;